// ModalContext.js
import { createContext, useContext, useState, ReactNode ,useEffect} from 'react';

interface ModalContextType {
  showAddDeviceModal: boolean;
  openAddDeviceModal: () => void;
  closeAddDeviceModal: () => void;
  userProducerCenterId: string;
  setUserProducerCenterIdValue: (value) => void;
  addDeviceStatus: boolean;
  addDeviceSuccessfully: () => void;
  addDeviceFailed: () => void;
  userProducerCenterCode: string;
  setUserProducerCenterCodeValue: (value) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

interface ModalProviderProps {
  children: ReactNode;
}

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const [addDeviceStatus, setAddDeviceStatus] = useState(false);
  const [userProducerCenterId, setUserProducerCenterId] = useState('');
  const [userProducerCenterCode, setUserProducerCenterCode] = useState('');

  useEffect(() => {
    const storedUserProducerCenterCode = localStorage.getItem('userProducerCenterCode');
    if (storedUserProducerCenterCode) {
      setUserProducerCenterCode(storedUserProducerCenterCode);
    }
    const storedUserProducerCenterId = localStorage.getItem('userProducerCenterId');
    if (storedUserProducerCenterId) {
      setUserProducerCenterId(storedUserProducerCenterId);
    }
  }, []);

  // Save userProducerCenterCode to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('userProducerCenterCode', userProducerCenterCode);
  }, [userProducerCenterCode]);

  useEffect(() => {
    localStorage.setItem('userProducerCenterId', userProducerCenterId);
  }, [userProducerCenterId]);

  const openAddDeviceModal = () => {
    setShowAddDeviceModal(true);
  };

  const closeAddDeviceModal = () => {
    setShowAddDeviceModal(false);
  };

  const setUserProducerCenterIdValue = (value) =>{
    setUserProducerCenterId(value)
  }

  const addDeviceSuccessfully = () => {
    setAddDeviceStatus(true);
  };

  const addDeviceFailed = () => {
    setAddDeviceStatus(false);
  };

  const setUserProducerCenterCodeValue = (value) =>{
    setUserProducerCenterCode(value)
  }
  const contextValue: ModalContextType = {
    showAddDeviceModal,
    openAddDeviceModal,
    closeAddDeviceModal,
    userProducerCenterId,
    setUserProducerCenterIdValue,
    addDeviceStatus,
    addDeviceSuccessfully,
    addDeviceFailed,
    userProducerCenterCode,
    setUserProducerCenterCodeValue
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
};
